import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import { useHistory, withRouter } from "react-router-dom";
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import Snackbar from "@material-ui/core/Snackbar";
import { ArrowLeft, ArrowRight, Camera, Delete, ArrowBack } from "@material-ui/icons";
import Box from "@material-ui/core/Box";
import { Card, Container, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// styles
import useSelfieStyles from "../../styles/selfieStyles";
import useStyles from "../../styles/index";

// context
import { useAuthDispatch, useAuthState } from "../../contexts/AuthContext";

// layout
import AuthLayout from "../../components/AuthLayout";
import { checkTokenRequest, getRandomRequest } from '../../api/auth';
import UpImage from '../../assets/img/up.png';
import DownImage from '../../assets/img/down.png';
import LeftImage from '../../assets/img/left.png';
import RightImage from '../../assets/img/right.png';
import SelfieithMovement from './SelfieithMovement';
import SelfieiWithText from './SelfieWithText';
import { sanaBaseUrl } from '../../constants';
import { StyledCard, StyledMotionImages, Image, StyledDialogMovement, StyledDialogMovementTitle, StyledTextContainer } from '../../styles/globalStyle';

import LeftArrow from '../../assets/img/leftArrow';

const getTranslate = (direction: string) => {
  switch (direction) {
    case "up":
      return `${UpImage}-بالا`;
    case "down":
      return `${DownImage}-پایین`;
    case "left":
      return `${LeftImage}-چپ`;
    case "right":
      return `${RightImage}-راست`;
    default:
      break;
  }
};



const typeOptions = [
  { value: "byVoice", label: "خواندن متن" },
  { value: "byMovment", label: "حرکت سر" },
];


//For change in time:
//1- const [remainSeconds, setRemainSeconds] = useState(8);
//2- setRemainSeconds(8);

// const SelfiePage = (props: any) => {
const SelfiePage = (props: any) => {


  const { authType } = props?.location?.state;


  const [authTypeValue, setAuthType] = React.useState(authType);

  const state = useAuthState();
  const dispatch = useAuthDispatch();
  const history = useHistory();
  // page vars
  const [openDialog, setOpenDialog] = useState(true);
  const [showVideo, setShowVideo] = useState(false);
  const [showSnack, setShowSnack] = useState(false);
  const [video, setVideo] = useState("");
  const [videoStream, setVideoStream] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = React.useState(0);


  // capturing
  const [recordedChunks, setRecordedChunks] = useState([]);
  const timer = useRef<number | null>(null);
  // style
  const [width, setWidth] = useState(100);
  const inputsContainer = useRef<null | HTMLDivElement>(null);
  const classes = useStyles();
  const selfieClasses = useSelfieStyles();



  const getRandom = async (
    uniqueId: string,

  ) => {
    try {
      const response = await getRandomRequest(uniqueId);

      localStorage.setItem('uniqueId', response.data.uniqueId);

      dispatch({
        type: "SET_REQ_INFO",
        selfieText: (response.data.randomMsgList as number[])
          .reverse()
          .reduce(
            (txt, number, index) => `${txt}${index > 0 ? "- " : ""}${number}`,
            ""
          ),
        selfieHeadDirec: (response.data.randomHeadDirecList as string[])
          .map((_dirction) => getTranslate(_dirction))
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // useEffect(() => {

  //   if (!!authTypeValue) {

  //     setTab(authTypeValue === 'byMovment' ? 0 : 1);
  //   }

  // }, [authTypeValue])

  //
  useEffect(() => {
    const boundingRect = inputsContainer.current!.getBoundingClientRect();
    dispatch({
      type: "SET_POSITION_INFO",
      positionInfo: {
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        height: boundingRect.height,
        width: boundingRect.width,
        fromTop: boundingRect.top,
        fromLeft: boundingRect.left,
      },
    });
  }, [dispatch, width]);



  useEffect(() => {
    setWidth(inputsContainer.current!.clientHeight);

    const uniqueId = localStorage.getItem('uniqueId');


    if (uniqueId) {
      getRandom(uniqueId);
    } else {
      setLoading(false);
    }

    let timerRemiander = setTimeout(() => {
      window.location.href = sanaBaseUrl;

    }, 600000); //in milliseconds

    return () => {

      clearTimeout(timerRemiander)
    };

  }, []);





  // const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
  //   setTab(newValue);

  //   setVideo('');
  //   setVideoStream([]);
  //   setShowVideo(false);

  //   if (newValue === 0) setAuthType("byMovment");
  //   if (newValue === 1) setAuthType("byVoice");
  // };

  const handleCameraValue = (value: string[]) => {

    if (value && value.length) {

      setVideoStream(value);


      const blob = new Blob(value, {
        type: "video/mp4",
      });

      const video = window.URL.createObjectURL(blob);
      setVideo(video);
      setShowVideo(true);
    }
  };


  // functions
  const reStart = () => {
    setShowVideo(false);
    setRecordedChunks([]);
    // setRemainSeconds(10);


    const uniqueId = localStorage.getItem('uniqueId');

    if (uniqueId) {
      getRandom(uniqueId);
    } else {
      setLoading(false);
    }
  };


  const next = async () => {
    if (videoStream?.length) {
      const blob = new Blob(videoStream, {
        type: "video/mp4",
      });
      dispatch({
        type: "SET_VIDEO",
        selfieVideo: blob,
      });
      history.replace({ pathname: "/verify", state: { authTypeValue } });

    } else {
      setShowSnack(true);
    }
  };


  const back = () => {
    history.replace("/selectAuthType");
  };



  return (

    <>
    {/* دیالوگ زیر دیالوگ قدیمی استفاده شده برای بخش راهنمای ویدئو سلفی بوده است که برای هماهنگی با بخش تصویر سلفی حذف شده است */}
       {/* <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      // fullScreen={window.innerWidth <= 600}
      >
        <StyledDialogMovement>

          <StyledDialogMovementTitle>
            <p> <b style={{ fontSize: '20px' }}>نحوه اخذ ویدئو سلفی:</b></p>
            <CloseOutlinedIcon onClick={() => setOpenDialog(false)} />

          </StyledDialogMovementTitle> */}

          {/* <p style={{ padding: '0px 24px', textAlign: 'center', fontSize: '18px' }}>به عنوان مثال در صورتی که سامانه، اعداد زیر را به کاربر نشان دهد:</p>
          <StyledCard>
            <StyledTextContainer>

              <p style={{ fontSize: '24px' }}>{'1-5-6-7'}</p>

              <LeftArrow className={'text__arrow'} />

            </StyledTextContainer>


          </StyledCard> */}
      
          {/* <div  className={'description'}>

            <span>متقاضی می بایست مراحل زیر را  <b style={{ fontSize: '18px', color: 'red' }}>یک بار</b>  انجام دهد:</span>
            <span>۱ - دوربین را به   <b style={{ fontSize: '18px', color: 'red' }}> صورت مستقیم </b>مقابل صورت خود ثابت نگه دارید.</span>
            <span> ۲ -  دکمه شروع ضبط ویدئو را فشار دهید.</span>
            <span> ۳ - پس از شروع ضبط ویدئو، اعداد داخل کادر را <b style={{ fontSize: '18px', color: 'red' }}> یکی یکی </b> با  <b style={{ fontSize: '18px', color: 'red' }}>  صدای بلند، شمرده </b>  و   <b style={{ fontSize: '18px', color: 'red' }}> از چپ به راست</b>  بخوانید</span>
            <span> ۴ -   از روشن بودن و دسترسی داشتن مرورگر به میکروفن و دوربین اطمینان حاصل کنید.</span>
            <span style={{ fontWeight: 'bold' }}> ۵ - صدای میکروفن خود را بلند کنید.</span>
            <span> ۶ -  در نهایت بر روی دکمه ارسال کلیک نمایید.</span>

          </div>
        </StyledDialogMovement>
      </Dialog>  */}


         <Dialog open={openDialog}>

                <DialogTitle id="simple-dialog-title">نحوه اخذ ویدئو سلفی</DialogTitle>

                <DialogContent>

                    <ul>
                        
                            {/* <DialogContentText className={classes.justifyText}>
                            متقاضی می بایست مراحل زیر را  <b style={{ fontSize: '18px', color: 'red' }}>یک بار</b>  انجام دهد:
                            </DialogContentText>
                         */}
                      
                      <DialogContentText className={classes.justifyText}>
                      می بایست ویدئو به صورت سلفی گرفته شود. تماس ویدئویی مورد تائید نیست. عزیزان خارج از کشور به منظور راهنمایی از 
  <b> <a href="https://vidaverify.ir/%d8%a7%d8%ad%d8%b1%d8%a7%d8%b2-%d9%87%d9%88%db%8c%d8%aa-%d8%af%db%8c%d8%ac%db%8c%d8%aa%d8%a7%d9%84-%d8%b3%d8%a7%d9%85%d8%a7%d9%86%d9%87-%d8%ab%d9%86%d8%a7/" rel="noreferrer"> این لینک </a></b> (انتهای صفحه، بخش سوالات متداول، سوال شماره چهارده) استفاده نمایند.


                             </DialogContentText>

                            <DialogContentText className={classes.justifyText}>
                            ۱ - دوربین را به   <b style={{ fontSize: '18px', color: 'red' }}> صورت مستقیم </b>و در راستای صورت خود، ثابت نگه دارید.                            </DialogContentText>
                           
                            <DialogContentText className={classes.justifyText}>
                            ۲ -  دکمه شروع ضبط ویدئو را کلیک کرده و بعد اعداد داخل کادر را <b style={{ fontSize: '18px', color: 'red' }}>یکی یکی</b>، با<b style={{ fontSize: '18px', color: 'red' }}>  صدای بلند، شمرده </b>  و   <b style={{ fontSize: '18px', color: 'red' }}> از چپ به راست</b>  بخوانید.
                            </DialogContentText>

                            <DialogContentText className={classes.justifyText}>
                            ۳ -   از روشن بودن و دسترسی داشتن مرورگر به میکروفن و دوربین اطمینان حاصل کنید.
                            </DialogContentText>

                            <DialogContentText className={classes.justifyText}>
                            ۴ - صدای میکروفن خود را<b style={{ fontSize: '18px', color: 'red' }}> بلند</b> کنید.
                            </DialogContentText>

                            <DialogContentText className={classes.justifyText}>
                            ۵ -  در نهایت بر روی دکمه ارسال کلیک نمایید.
                            </DialogContentText>
                           
                      
                    </ul>
         
               <br/>               
                <b style={{ fontSize: '18px' }}>       راه حل برطرف کردن خطای عدم ضبط ویدئو سلفی: </b> 
             
              <ul>                      
                           
                       <DialogContentText className={classes.justifyText}>
                      
                         در صورتی که به هنگام ضبط ویدئو سلفی، شمارنده تا عدد یک شروع به شمارش می کند ولی در نهایت ویدئویی ضبط نمی شود خطایی در سمت مرورگرتان به وجود آمده است. در صورت امکان کش مرورگر خود را پاک کنید و یا از مرورگر دیگری مانند فایرفاکس بدون نیاز به پرداخت هزینه مجدد اقدام کنید.

                       </DialogContentText>
                     
                  </ul>

                  </DialogContent>
                <br/> 
               

                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">
                        ادامه
                    </Button>
                </DialogActions>
            </Dialog> 


      <AuthLayout showInfo={false}>

        <div className={classes.root}>

          {/* <AppBar position="static">
            <Tabs
              value={tab}
              onChange={handleChangeTab}
              aria-label="simple tabs example"
            >
              <Tab label="حرکت سر" />
              <Tab label="خواندن متن" />
            </Tabs>
          </AppBar> */}

          <Container className={`${classes.content} content__responsive`}>
            <div
              ref={inputsContainer}
              className={classes.inputsContainer}
            // style={{ width: `${width}px` }}
            >
              
              {authTypeValue === 'byVoice' && <HelpOutlineOutlinedIcon className={'qutation__icon'} onClick={() => setOpenDialog(true)} />}

              {showVideo ? (
                <div className={classes.inputContainer}>
                  <video
                    src={video}
                    controls={false}
                    loop={true}
                    autoPlay={true}
                    playsInline={true}
                    muted={false}
                    className={selfieClasses.video}
                  />

                  <div
                    className={selfieClasses.videoButtons}
                    style={{ top: "5px" }}
                  >

                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<Delete />}
                      onClick={reStart}
                    >
                      حذف
                    </Button>

                  </div>
                </div>
              ) : (
                <div className={classes.inputContainer}>
                  {

                    <SelfieiWithText
                      showVideo={showVideo}
                      state={state}
                      onValue={handleCameraValue}
                    />
                    // tab === 0 ?
                    //   (
                    //     <SelfieithMovement
                    //       showVideo={showVideo}
                    //       state={state}
                    //       onValue={handleCameraValue}
                    //     />
                    //   )
                    //   :
                    //   (
                    //     <SelfieiWithText
                    //       showVideo={showVideo}
                    //       state={state}
                    //       onValue={handleCameraValue}
                    //     />
                    //   )
                  }

                </div>
              )}
            </div>
            <Typography className={selfieClasses.info}>
              صورت خود را کاملا داخل کادر بیضی شکل قرار دهید. دکمه شروع را کلیک و بعد اعداد داخل کادر سفید رنگ بالای صفحه را <b style={{ color: 'red' }}>یکی یکی</b>، با <b style={{ color: 'red' }}>صدای بلند</b>،  <b style={{ color: 'red' }}>شمرده</b> و از
              <b style={{ color: 'red' }}> چپ به راست </b> بگویید.
            </Typography>
            {/*             
          // ) : (
          //   <Typography className={selfieClasses.info}>
          //     پس از شروع ضبط ویدئو, سر خود را به ترتیب به جهت یا جهت های خواسته
          //     شده بچرخانید.
          //   </Typography>
          //    )} */}


            <div className={classes.actionBar}>
              <Button
                variant="outlined"
                color="primary"
                className="last"
                startIcon={<ArrowRight />}
                onClick={back}
              >
                مرحله قبل
              </Button>
              <Button
                variant="outlined"
                color="primary"
                endIcon={<ArrowLeft />}
                onClick={next}
              >
               ارسال
              </Button>
            </div>
          </Container>
        </div>


        <Snackbar
          open={showSnack}
          message="لطفا ویدئو سلفی بگیرید."
          onClose={() => setShowSnack(false)}
        />
      </AuthLayout>
    </>
  );
};

export default withRouter(SelfiePage);
